export default __webpack_public_path__ + "static/media/order-example.292ecbf3.svg";